import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { destinations } from "../../data/homeData";
import CountryFlagIcon from "../common/CountryFlagIcon";

function DestinationsSection() {
  const renderCard = (country, isLarge) => (
    <motion.article
      key={country.slug}
      whileHover={{ y: -8 }}
      transition={{ duration: 0.28, ease: "easeOut" }}
      className="group overflow-hidden rounded-2xl md:rounded-[1.6rem] border border-midnight-navy/12 bg-white shadow-[0_12px_24px_-12px_rgba(7,18,38,0.1)] transition-shadow duration-300 hover:shadow-[0_24px_48px_-16px_rgba(7,18,38,0.2)] destination-shine"
    >
      <Link className="block h-full w-full" to={`/study-in/${country.slug}`}>
        <div className={`relative ${isLarge ? 'aspect-[4/5] sm:aspect-[4/3] lg:aspect-[4/5]' : 'aspect-square xl:aspect-[3/4]'} overflow-hidden`}>
          <img
            src={country.image}
            alt={`${country.name} study destination`}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-midnight-navy/95 via-midnight-navy/30 to-transparent" />

          <div className="absolute left-3 top-3 inline-flex items-center gap-2 rounded-full bg-soft-white/95 px-3 py-1.5 text-[11px] font-bold text-midnight-navy shadow-sm">
            <CountryFlagIcon slug={country.slug} name={country.name} width={16} height={11} />
            {country.name}
          </div>

          <div className={`absolute inset-x-3 bottom-3 p-3 lg:p-4 ${isLarge ? '' : 'sm:p-3'}`}>
            <p className="text-[11px] md:text-sm font-medium leading-relaxed text-soft-white drop-shadow-md">
              {country.hook}
            </p>
            <span className="mt-2 md:mt-3 inline-flex items-center gap-1.5 text-[10px] md:text-xs font-bold uppercase tracking-[0.15em] text-warm-gold">
              Explore
              <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );

  return (
    <MotionSection id="destinations" className="relative py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Study In"
          title="Explore World-Class Education Destinations"
          description="Choose from top global destinations with tailored advice for your profile, academic goals, and long-term plans."
        />

        <div className="mt-12 flex flex-col gap-6 md:gap-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {destinations.slice(0, 3).map((country) => renderCard(country, true))}
          </div>
          <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4">
            {destinations.slice(3).map((country) => renderCard(country, false))}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default DestinationsSection;
